import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { PLACEMENT_POSITIONS } from 'utils/constants/components/popover'
import { Popover } from 'components/popover/Popover'

import styles from './DropdownView.module.scss'

export const DropdownView = ({
  children,
  className,
  dataTestId,
  footerRenderer,
  headerRenderer = () => {},
  triggerElementRenderer,
  placement = 'bottom-start',
  width,

  // inner
  containerRef,
  handlePopoverToggle,
  isOpen,
  setContainerRef,
}) => {
  const style = {}

  if (!width) {
    style.width = containerRef && containerRef.getBoundingClientRect().width
  } else {
    style.width = width
  }

  return (
    <div>
      <div className={classNames(styles.container, className)} data-test-id={dataTestId} ref={setContainerRef}>
        {triggerElementRenderer({ handlePopoverToggle, isOpen })}

        <Popover onHide={handlePopoverToggle} isOpen={isOpen} placement={placement}>
          {({ scheduleUpdate }) => (
            <div className="dropdown-popover-wrapper" style={style}>
              {headerRenderer && headerRenderer({ handlePopoverToggle, isOpen, scheduleUpdate })}

              {children({ handlePopoverToggle, isOpen, scheduleUpdate })}
            </div>
          )}
        </Popover>
      </div>

      {footerRenderer && footerRenderer({ handlePopoverToggle, isOpen })}
    </div>
  )
}

DropdownView.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  footerRenderer: PropTypes.func,
  headerRenderer: PropTypes.func,
  placement: PropTypes.oneOf(PLACEMENT_POSITIONS),
  triggerElementRenderer: PropTypes.func.isRequired,
  width: PropTypes.number,

  // inner
  containerRef: PropTypes.instanceOf(Element), // eslint-disable-line
  handlePopoverToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setContainerRef: PropTypes.func.isRequired,
}
